import { onResetModuleCommand } from 'owa-calendar-module-command';
import { clearSelectedItem } from 'owa-calendar-surface';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { orchestrator } from 'satcheljs';

orchestrator(onResetModuleCommand, () => {
    // once the module command is reset, clear the selected item if at all there is still one
    clearSelectedItem(getSurfaceStore());
});
